export default "__VITE_ASSET__zn5bGifH__"